import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/styles/tailwind.css";
import "quill/dist/quill.snow.css";
import { vBottomSheet } from "@/directives/bottomSheet";

createApp(App)
  .use(store)
  .use(router)
  .directive("bottom-sheet", vBottomSheet)
  .mount("#app");
